module.exports = "img/flags/KH.5989492.png";